<div class="container" laasFullToHalf  [fullToHalfObj]="{ obj1: importDetailParams, obj2: searchParams }">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'Menu.Menu.ReceiptFormQuery' | translate }}</h1>
  <p-card>
      <p-accordion (onOpen)="accordionTabOpen()">
          <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
              <form [formGroup]="searchForm">
                  <div class="p-fluid grid">

                    <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                        <label>{{ 'ReceiptForm.Search.ReceiptNumber' | translate }}</label>
                        <p-chips formControlName="whNoList" [(ngModel)]="searchParams.whNoList" separator=","
                        (onAdd)="chipsAdd($event, 'whNoList')"></p-chips>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.ImportDeclarationNum' | translate }}</label>
                      <p-chips formControlName="importDeclarationNoList" [(ngModel)]="searchParams.importDeclarationNoList" separator=","
                      (onAdd)="chipsAdd($event, 'importDeclarationNoList')"  ></p-chips>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.DocumentType' | translate }}</label>
                      <p-multiSelect formControlName="deliveryTypeList"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                  [(ngModel)]="searchParams.deliveryTypeList"
                                  [options]="deliveryOptions"
                                  [filter]="true"
                                  filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.ReceivingStatus' | translate }}</label>
                      <p-multiSelect formControlName="whStatusList"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                  [(ngModel)]="searchParams.whStatusList"
                                  [options]="whDocStatusOptions"
                                  [filter]="true"
                                  filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.Forwarder' | translate }}</label>
                      <p-multiSelect formControlName="shipperList"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                  [(ngModel)]="searchParams.shipperList"
                                  [options]="bookingForwarderOptions"
                                  [filter]="true"
                                  filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.TradeTerm' | translate }}</label>
                      <p-multiSelect formControlName="shipTermList"
                                  optionLabel="label"
                                  optionValue="value"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                  [(ngModel)]="searchParams.shipTermList"
                                  [options]="shipTermOptions"
                                  [filter]="true"
                                  filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.Supplier' | translate }}</label>
                      <p-dropdown #vc formControlName="vendorCustomer" optionLabel="label" optionValue="value"   [(ngModel)]="searchParams.vendorCustomer"
                      [options]="vendorOptions" [filter]="true"  (onFilter)="getVendorOptions($event,vc)"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}" ></p-dropdown>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.OriginCountry' | translate }}</label>
                      <p-multiSelect formControlName="fromCountryList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.fromCountryList"
                                [options]="countryOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}} laas-calendar" >
                      <laas-calendar
                        #receiptFormDate
                        [title]="'ReceiptForm.Search.ReceiptFormCreation'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="dateOnChange($event,'receiptFormDate')">
                      </laas-calendar>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}} laas-calendar" >
                      <laas-calendar
                        #receivingDate
                        [title]="'ReceiptForm.Search.ReceivingDate'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        [showCustomTime]="true"
                        (onDateChange)="dateOnChange($event,'receivingDate')">
                      </laas-calendar>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}} laas-calendar" >
                      <laas-calendar
                        #checkInDate
                        [title]="'ReceiptForm.Search.CheckInDate'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="dateOnChange($event,'checkInDate')">
                      </laas-calendar>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}} laas-calendar" >
                      <laas-calendar
                        #flightDate
                        [title]="'ReceiptForm.Search.FlightDate'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="dateOnChange($event,'flightDate')">
                      </laas-calendar>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.DeclarationType' | translate }}</label>
                      <p-multiSelect formControlName="docTypeList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.docTypeList"
                                [options]="docTypeOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.IdentificaitonNum' | translate }}</label>
                      <p-chips formControlName="docNo" [(ngModel)]="searchParams.docNo" separator=","
                        (onAdd)="chipsAdd($event, 'docNo')"></p-chips>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}} laas-calendar" >
                      <laas-calendar
                        #declarationDate
                        [title]="'ReceiptForm.Search.DeclarationDate'"
                        [enableMaxDateIsToday]="false"
                        [showRangeMode]="true"
                        [showStartMode]="true"
                        (onDateChange)="dateOnChange($event,'declarationDate')">
                      </laas-calendar>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.CustomsDeclarationMethod' | translate }}</label>
                      <p-multiSelect formControlName="importTypeList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.importTypeList"
                                [options]="importTypeOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.Brand' | translate }}</label>
                      <p-dropdown formControlName="brand"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.brand"
                                [options]="brandOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-dropdown>
                    </div>

                    <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.HAWB' | translate }}</label>
                      <p-chips formControlName="hawbNoList" [(ngModel)]="searchParams.hawbNoList" separator="," (onAdd)="chipsAdd($event, 'hawbNoList')"></p-chips>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.MAWB' | translate }}</label>
                      <input pInputText type="text" formControlName="mawbNo" [(ngModel)]="searchParams.mawbNo" />
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.CaseNum' | translate }}</label>
                      <input pInputText type="text" formControlName="applyNo" [(ngModel)]="searchParams.applyNo" />
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.Company' | translate }}</label>
                      <p-multiSelect formControlName="orgIdList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.orgIdList"
                                [options]="letterHeadOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.OriginalReceiptForm' | translate }}</label>
                      <input pInputText type="text" formControlName="originWhNo" [(ngModel)]="searchParams.originWhNo" />
                    </div>

                    <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.ReceiptNum' | translate }}</label>
                      <input pInputText type="text" formControlName="referenceKey" [(ngModel)]="searchParams.referenceKey" />
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.WarehouseAddress' | translate }}</label>
                      <p-multiSelect formControlName="addressCodeList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.addressCodeList"
                                [options]="pickupLocationOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.DeliveryMode' | translate }}</label>
                      <p-multiSelect formControlName="shippingMethodList"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                                [(ngModel)]="searchParams.shippingMethodList"
                                [options]="shipMethodOptions"
                                [filter]="true"
                                filterBy="label">
                      </p-multiSelect>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.GenerateExpenses' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="isGenerateFee" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.isGenerateFee"
                        [options]="isGenerateFeeOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.CustomsBondedNum' | translate }}</label>
                      <p-chips formControlName="bondedNoList" [(ngModel)]="searchParams.bondedNoList" separator=","
                       (onAdd)="chipsAdd($event, 'bondedNoList')"></p-chips>
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.Creator' | translate }}</label>
                      <input pInputText type="text" formControlName="createUser" [(ngModel)]="searchParams.createUser" />
                    </div>

                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.IsFeeCalculation' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="isFeeCalculation" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.isFeeCalculation"
                        [options]="isFeeCalculationOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.ExistedAdNoFlag' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="existedAdNoFlag" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.existedAdNoFlag"
                        [options]="existedAdNoOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.AlreadynotifiedFlag' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="alreadyNotifiedFlag" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.alreadynotifiedFlag"
                        [options]="alreadynotifiedOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.AlreadyUploadedFlag' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="alreadyUploadedFlag" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.alreadyUploadedFlag"
                        [options]="alreadyUploadedOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.ShippingProcessedRemainingFlag' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="shippingProcessedRemainingFlag" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.shippingProcessedRemainingFlag"
                        [options]="shippingProcessedRemainingOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.PcsrProcessedRemainingFlag' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="pcsrProcessedRemainingFlag" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.pcsrProcessedRemainingFlag"
                        [options]="pcsrProcessedRemainingOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'hidden' : 'col-3'}}">
                      <label>{{ 'ReceiptForm.Search.CalculationUnit' | translate }}</label>
                      <div class="item">
                        <p-dropdown formControlName="uom" optionLabel="label" optionValue="value"  [(ngModel)]="searchParams.uom"
                        [options]="carTypeOptions"   styleClass="p-text-left" [showClear]="true"
                        placeholder="{{ 'Common.Message.ChooseOption' | translate }}"  ></p-dropdown>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-3 mb-3">
                      <label>{{ 'BookingSearch.Form.Facility' | translate }}</label>
                      <div class="item">
                        <laas-facility-dropdown
                          formControlName="facilityList"
                          [isMultiple]="true"
                          [showClear]="false"
                          [showFilter]="true"
                          [defaultSelectFirst]="true"
                          [showToggleAll]="true"
                          (onOptionDataChange)="optionsDataOnChange($event, 'facilityList')"
                        >
                        </laas-facility-dropdown>
                      </div>
                    </div>
                    <div class="field {{isRwd ? 'col-12' : 'col-3'}}">
                        <label>{{ 'TruckCostAllocation.MainTable.CrossBoundryNo' | translate }}</label>
                        <p-chips formControlName="crossBoundryNoList" [(ngModel)]="searchParams.crossBoundryNoList" separator=","
                        (onAdd)="chipsAdd($event, 'crossBoundryNoList')"></p-chips>
                    </div>

                  </div>

                  <div class="grid">
                      <div class="col">
                          <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
                          <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-4" (click)="resetBtn()" ></button>
                          <laas-permission-button permissionCode="BtnReceiptFormDownload" label="{{ 'ReceiptForm.Button.ReceiptFormDownload' | translate }}" [class]="'p-button ml-2'" (onClick)="downloadWarehousing()"></laas-permission-button>
                          <laas-permission-button permissionCode="BtnGETsDownload" label="{{ 'ReceiptForm.Button.GETsDownload' | translate }}" [class]="'p-button ml-2'" (onClick)="getsDownload()"></laas-permission-button>
                          <laas-permission-button permissionCode="BtnBatchUpdate" label="{{ 'ReceiptForm.Button.BatchUpdate' | translate }}" [class]="'p-button ml-2'" (onClick)="openUpdateBondedNoModal()"></laas-permission-button>
                      </div>
                  </div>

              </form>
          </p-accordionTab>
      </p-accordion>

      <div class="mt-2">
        <laas-data-table id="warehousingSearchMainTable" #table [expandable]="true" (rowExpanded)="searchDetailClick($event)" [tableKey]="preferenceKey" [selectable]="true" [dataKey]="'whNo'" [value]="searchResults"
        [loading]="isLoading"  [defaultColumns]="columns" (tableOnPage)="tablePageChange($event)" (tableOnSort)="tableSort($event)" [lazy]="true" [style]="{ overflow: 'auto' }">
            <ng-template pTemplate="caption">
              <p-menubar *ngIf="mainItemMenus.length > 0" [model]="mainItemMenus" [class]="isRwd ? 'col': ''" [style]="isRwd ? { width: '120px' } : {}" styleClass="ml-2"></p-menubar>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expand">
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">

                      <ng-container *ngSwitchCase="'whNo'">
                        <div class="overflow-text">
                          <a href="javascript: void(0);" (click)="linkClick($event, rowData)">{{rowData[col.field]}}</a>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'importDeclarationNo'">
                        <div class="overflow-text">
                          <a href="javascript: void(0);" (click)="importLinkClick($event, rowData)">{{rowData[col.field]}}</a>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'isPrint'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOption | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'orgId'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'billCorp'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:letterHeadOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'deliveryType'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:deliveryOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'urgentFlag'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping: urgentFlagOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'isGenerateFee'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOption | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'whStatus'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:whDocStatusOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'shipTerm'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:shipTermOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'shipper'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'whDt'">
                        <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'expectedDt'">
                        <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'fromCountry'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'fromCity'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'fromArea'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allAreaOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'brand'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:brandOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'addressCode'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:pickupLocationOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'flightDt'">
                        <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'createDt'">
                        <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'updateDt'">
                        <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</div>
                      </ng-container>


                      <ng-container *ngSwitchCase="'toCity'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'deliverySubType'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:deliverySubTypeOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'permitType'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOption | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'isDropShipment'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:yesNoOption | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'isFeeCalculation'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:isFeeCalculationOptions | replaceNullWith:'-' }}</div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'uom'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:carTypeOptions | replaceNullWith:'-' }}</div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'consolidationForwarder'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}</div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'crossBoundryForwarder'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:bookingForwarderOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'consolidationFromCountry'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'consolidationFromCity'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'consolidationFromArea'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allAreaOptions | replaceNullWith:'-' }}</div>
                      </ng-container>
                        <ng-container *ngSwitchCase="'consolidationToCountry'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'consolidationToCity'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allCityOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'consolidationToArea'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allAreaOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'billObjectType'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:billObjectTypeOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'billObject'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:billObjectOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'toCountry'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:countryOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'toArea'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:allAreaOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchCase="'shippingMethod'">
                        <div class="overflow-text">{{ rowData[col.field] | optionsMapping:shipMethodOptions | replaceNullWith:'-' }}</div>
                      </ng-container>

                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith:'-'}}
                        </div>
                      </ng-container>

                    </ng-container>
                </td>
            </ng-template>

            <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
              <ng-container *ngTemplateOutlet="rowExpandTable; context: { data: rowData, index: rowIndex }"></ng-container>
              <p-dialog *ngIf="isRwd" header="{{ 'ReceiptForm.SubTable.ReceiptFormDetail' | translate }}" appendTo="body" [(visible)]="isShowDetailModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '90%' }">
                <div *ngTemplateOutlet="rowExpandTable; context: { data: rowData, index: rowIndex }"></div>
              </p-dialog>
            </ng-template>
        </laas-data-table>

    </div>

  </p-card>

  <p-dialog header="{{ 'ReceiptFormImport.Import' | translate }}"
   appendTo="body"
   [(visible)]="isShowImportModal"
   [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
    <form [formGroup]="importForm">
      <div *ngIf="isLoadingImportDetail" class="loadingMask">
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="p-fluid grid">
        <div class="field col-12">
          <label>{{ 'ReceiptFormImport.DocumentSource' | translate }}</label>
          <p-dropdown appendTo="body" (onChange)="changeSourceType($event)" formControlName="sourceType" [filter]="true" [options]="sourceTypeList" [(ngModel)]="importDetailParams.sourceType" [class]="(importSubmitted && f(importForm).sourceType.errors) ? ['ng-invalid', 'ng-dirty'] : []" placeholder="{{ 'Common.Message.ChooseOption' | translate}}"></p-dropdown>
          <small *ngIf="importSubmitted && f(importForm).sourceType.errors" class="errors">
            <div *ngIf="f(importForm).sourceType.errors.required" class="p-invalid">{{ 'ReceiptFormImport.DocumentSource' | translate }} is required</div>
          </small>
        </div>
        <div class="field col-12">
          <label>{{ 'ReceiptFormImport.DocumentNum' | translate }}</label>
          <p-chips formControlName="referenceKey" [(ngModel)]="importDetailParams.referenceKey" (onAdd)="importFormChipsAdd($event, 'referenceKey')" separator="," [class]="(importSubmitted && f(importForm).referenceKey.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-chips>
          <small *ngIf="importSubmitted && f(importForm).referenceKey.errors" class="errors">
            <div *ngIf="f(importForm).referenceKey.errors.required" class="p-invalid">{{ 'ReceiptFormImport.DocumentNum' | translate }} is required</div>
          </small>
        </div>
        <div  *ngIf="displayADImportWidget('trxDtTmp')" class="field col-12">
          <label>{{ 'ReceiptFormImport.DocumentDate' | translate }}</label>
          <p-calendar appendTo="body" formControlName="trxDtTmp" [(ngModel)]="importDetailParams.trxDtTmp" dateFormat="yy/mm/dd" [class]="(importSubmitted && f(importForm).trxDtTmp.errors) ? ['ng-invalid', 'ng-dirty'] : []">
          </p-calendar>
          <small *ngIf="importSubmitted && f(importForm).trxDtTmp.errors" class="errors">
            <div *ngIf="f(importForm).trxDtTmp.errors.required" class="p-invalid">{{ 'ReceiptFormImport.DocumentDate' | translate }} is required</div>
          </small>
        </div>
        <div *ngIf="displayADImportWidget('trxAmount')" class="field col-12">
          <label>{{ 'ReceiptFormImport.AccountingAnt' | translate }}</label>
          <p-inputNumber formControlName="trxAmount"
              mode="decimal" [minFractionDigits]="2" [(ngModel)]="importDetailParams.trxAmount" styleClass="text-right" [class]="(importSubmitted && f(importForm).trxAmount.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-inputNumber>
          <small *ngIf="importSubmitted && f(importForm).trxAmount.errors" class="errors">
            <div *ngIf="f(importForm).trxAmount.errors.required" class="p-invalid">{{ 'ReceiptFormImport.AccountingAnt' | translate }} is required</div>
          </small>
        </div>
        <div *ngIf="displayADImportWidget('pcsrDept')" class="field col-12">
          <label>{{ 'ReceiptFormImport.PCSRDept' | translate }}</label>
          <input pInputText type="text" formControlName="pcsrDept" [(ngModel)]="importDetailParams.pcsrDept" />
        </div>
        <div *ngIf="displayADImportWidget('brand')" class="field col-12">
          <label>{{ 'ReceiptFormImport.Brand' | translate }}</label>
          <p-dropdown appendTo="body" formControlName="brand" [filter]="true" [options]="brandList" [(ngModel)]="importDetailParams.brand" [class]="(importSubmitted && f(importForm).brand.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-dropdown>
          <small *ngIf="importSubmitted && f(importForm).brand.errors" class="errors">
            <div *ngIf="f(importForm).brand.errors.required" class="p-invalid">{{ 'ReceiptFormImport.Brand' | translate }} is required</div>
          </small>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" (click)="importDetailBtnClick($event)" [disabled]="importForm.invalid || isLoadingImportDetail"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeImportDetailModal($event)" class="p-button-secondary ml-2"></button>
        </div>
      </div>
    </form>
  </p-dialog>


  <p-dialog header="{{ 'ReceiptForm.Button.BatchUpdate' | translate }}" appendTo="body" [(visible)]="isShowUpdateBondedNoModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">


    <div class="field col-12">
      <label>{{ 'ReceiptFormBatchUpdate.File' | translate }}</label>
      <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="fileUploader($event)"
          chooseLabel="{{ 'ReceiptFormBatchUpdate.Select' | translate }}" uploadLabel="{{ 'ReceiptFormBatchUpdate.Upload' | translate }}" cancelLabel="{{ 'ReceiptFormBatchUpdate.Cancel' | translate }}" accept=".xls,.xlsx"   >

          <ng-template pTemplate="toolbar">
            <button #uploadBtn pButton pRipple label="{{ 'ReceiptForm.Button.Template' | translate }}"   class="p-button-info ml-1"   (click)="batchUpdateWHTemplateBtn()"></button>
          </ng-template>


      </p-fileUpload>

    </div>

    <div class="grid">
      <div class="col">
        <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeUpdateBondedNoModal($event)" class="p-button-secondary ml-2"></button>
      </div>
    </div>

  </p-dialog>

  <p-dialog header="{{ 'ReceiptFormImportDrop.ImportDropDO' | translate }}" appendTo="body" [(visible)]="isShowImportDropShipModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
    <form [formGroup]="importDropShipForm">
      <div *ngIf="isLoadingImportDropShip" class="loadingMask">
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="p-fluid grid">
        <div class="field col-12">
          <label>{{ 'ReceiptFormImportDrop.DocumentNum' | translate }}</label>
          <p-chips formControlName="referenceKey" [(ngModel)]="importDropShipParams.referenceKey" separator="," (onAdd)="importDropShipFormChipsAdd($event, 'referenceKey')" [class]="(importDropShipSubmitted && f(importDropShipForm).referenceKey.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-chips>
          <small *ngIf="importSubmitted && f(importDropShipForm).referenceKey.errors" class="errors">
            <div *ngIf="f(importDropShipForm).referenceKey.errors.required" class="p-invalid">{{ 'ReceiptFormImportDrop.DocumentNum' | translate }} is required</div>
          </small>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" (click)="importDropShipBtnClick($event)" [disabled]="(importDropShipForm.invalid)||isLoadingImportDropShip"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeImportDropShipModal($event)" class="p-button-secondary ml-2"></button>
        </div>
      </div>
    </form>
  </p-dialog>

</div>

<ng-template #rowExpandTable let-rowData="data" let-rowIndex="index">
  <laas-data-table [tableKey]="preferenceKey2"  [dataKey]="'seqNo'"
      [(selectedRows)]="seqNoList"  [selectable]="true"
      [value]="rowData.warehousingDetail" [defaultColumns]="detailColumns" [selectionMode]="'multiple'" [paginator]="false"
      [style]="{ overflow: 'auto' }">

      <ng-template pTemplate="caption">
        <p-menubar *ngIf="itemMenus.length > 0" [model]="itemMenus" [class]="isRwd ? 'col': ''" [style]="isRwd ? { width: '120px' } : {}" styleClass="ml-2"></p-menubar>
      </ng-template>

        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <td *ngFor="let col of columns">
                <div *ngIf="isRwd">
                  <b>{{ col.header }}</b>
                </div>
                <div [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'__delete'">
                      <span *ngIf="isShowDeleteIcon(rowIndex, rowData)" class="icon" (click)="deleteBtnClick($event, rowIndex, rowData)"><i class="fas fa-trash-alt"></i></span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'whDetailStatus'">
                      <div class="overflow-text">
                        {{ rowData[col.field]  | optionsMapping:whDetailStatusOptions | replaceNullWith:'-'  }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'orgId'">
                      <div class="overflow-text">
                        {{ rowData[col.field]  | optionsMapping:letterHeadOptions | replaceNullWith:'-'  }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'sourceType'">
                      <div class="overflow-text">
                        {{ rowData[col.field]  | optionsMapping:sourceTypeList | replaceNullWith:'-'  }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'shipCorp'">
                      <div class="overflow-text">
                        {{ rowData[col.field]  | optionsMapping:letterHeadOptions | replaceNullWith:'-'  }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'trxDt'">
                      <div class="overflow-text">
                        {{ rowData[col.field] |  date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone|  replaceNullWith:'-' }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'createDt'">
                      <div class="overflow-text">
                        {{ rowData[col.field] |  date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |  replaceNullWith:'-' }}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'updateDt'">
                      <div class="overflow-text">
                        {{ rowData[col.field] |  date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone |  replaceNullWith:'-' }}
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="'amount'">
                      <div class="overflow-text">
                        {{ rowData[col.field] | number }}
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <div class="overflow-text">
                        {{ rowData[col.field] | replaceNullWith:'-'}}
                      </div>
                    </ng-container>

                </div>
            </td>
        </ng-template>
  </laas-data-table>
</ng-template>

<ng-container *ngIf="isShowAssignModal">
  <laas-assign-warehousing   [(visible)]="isShowAssignModal"    [whNo]="clickWhNo"     ></laas-assign-warehousing>
</ng-container>

<ng-container *ngIf="isShowCopyModal">
  <laas-copy-warehousing   [(visible)]="isShowCopyModal"    [whNo]="clickWhNo"   (newWhNo)="closeCopyView($event)"     ></laas-copy-warehousing>
</ng-container>


<laas-multiple-dofile-management [display]="showDoFile" (onClose)="closeFile($event)" [doFileList]="whNoFileList">
</laas-multiple-dofile-management>

<laas-billing-viewer [display]="isShowBillingViewerModal" [bookingNo]="bookingNoFile" [bookingInfo]="bookingInfo" [feature]="'Warehousing'" (onClose)="closeBilling($event)"></laas-billing-viewer>

<laas-billing-preview-calculate [display]="isShowBillingPreviewCalculateViewerModal" [bookingNo]="bookingNoPreviewCalculate" [feature]="'Warehousing'"  (onClose)="closeBillingPreviewCalculate($event)"></laas-billing-preview-calculate>

<laas-remaining-sku [(visible)]="isShowRemainingSkuModal" [whNo]="remainingSkuWhNo" (dataTransferEvent)="closeRemainingSkuDialog($event)"></laas-remaining-sku>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
